import styles from "./styles.scss";
import Avatar from "../avatar";
import { Body } from "../typography";
import { CurrentUserContext, OrganizationContext } from "../../contexts";
import { useContext } from "preact/hooks";
import { Row } from "../Layout/Layout";

const ChatListEmpty = () => {
  let { loading, profiles, name } = useContext(OrganizationContext);
  const { internalId } = useContext(CurrentUserContext);

  // noinspection JSUnresolvedVariable
  profiles = profiles
    ? profiles.filter(p => p.internal_id !== internalId)
    : null;

  return (
    <div className={styles.emptyContent}>
      {loading ? (
        <div className={styles.wrapper}>
          <div>
            <Avatar src="https://placehold.it/40x40" />
            <Avatar
              style={{ marginLeft: ".25rem" }}
              src="https://placehold.it/40x40"
            />
            <Avatar
              style={{ marginLeft: ".25rem" }}
              src="https://placehold.it/40x40"
            />
            <Avatar
              style={{ marginLeft: ".25rem" }}
              src="https://placehold.it/40x40"
            />
            <Avatar
              style={{ marginLeft: ".25rem" }}
              src="https://placehold.it/40x40"
            />
          </div>
          <Body weight="bold">Carregando contatos...</Body>
        </div>
      ) : (
          <div className={styles.wrapper}>
            <Body>{renderSubtitle(name, profiles.length)}</Body>
          </div>
        )}
    </div>
  );
};

const renderSubtitle = (name, totalProfiles, namesShown = 3) => {
  return `Você ainda não está em nenhuma conversa.`;
};

export default ChatListEmpty;



// WEBPACK FOOTER //
// ./components/chat-list-empty/index.js